import { OmniStringToDate } from "../../utils/helpers";
import constants from "../../assets/constants";

export const formatDateLabels = dates => {
  const labels = [];
  let lastYear = "";
  for (let i = 0; i < dates.length; i++) {
    let aDate = OmniStringToDate(dates[i]);
    labels.push(
      `${constants.monthNames[aDate.getMonth()]} ${aDate.getUTCDate()} ${
        lastYear !== aDate.getFullYear() ? (lastYear = aDate.getFullYear()) : ""
      }`
    );
  }
  return labels;
};

export const extractGraphDataFromArray = objArray => {
  let labels = objArray.map(a => a.date).slice(0);
  let values = objArray.map(a => a.value).slice(0);

  return { labels, values };
};
